module.exports = "<span [class.unl]=\"isNum\">{{unit}}</span>"


//////////////////
// WEBPACK FOOTER
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/shared/components/unit-no/unit-no.component.html
// module id = ../../../../../src/app/shared/components/unit-no/unit-no.component.html
// module chunks = main